import React, {useEffect, useState} from 'react';
import HeaderTitle from './header';
import {PriorizationDateTable} from './table/table';
import {Card, Dimmer, Loader, Modal, Button} from 'semantic-ui-react';
import {useDispatch, useSelector} from 'react-redux';
import './styles.scss';
import OrderModal from './ordersModal';
import {Actions} from '../../../common/actions';
import {applyFilters} from '../../utils/commonUtils';
import {tableColumnsWithProps} from './table/columns';
import UpdateDatesModal from './updateDatesModal';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import UpdateComboModal from './updateComboModal';
import UpdateAgencyModal from './updateAgencyModal';
import {filterPriorizationOptions, filterPriorizationVehTypeOptions} from '../../constants/filterPriorizationOptions';
import PriorizationModal from './priorizationModal';
import {datesType, priorizationType} from '../../constants/selectTypes';


const {
  fetchDealers,
  fetchGetPriorizationData,
  fetchGetFreeDatesLogistic,
  fetchPriorizationCombos,
  navigateTo,
  setSelectedVehicleCombo,
  setSelectedVehicleAgency,
  fetchAgenciesByDealer,
} = Actions;

// Comentado con // lo que podría ir en redux
const PriorizationDate = () => {
  const [openOrders, setOpenOrders] = useState(false);//
  const [openUpdateDates, setOpenUpdateDates] = useState(false);//
  const [openComboModal, setOpenComboModal] = useState(false);//
  
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.session.permissions);
  const {data, loading, updateSuccess} = useSelector((state) => state.priorizationDates);
  const isUserTDE = useSelector((state) => state.session.isUserFromTDE);

  const [userType, setUserType] = useState(null); //
  const [selectMode, setSelectMode] = useState(false); //
  const [selectType, setSelectType] = useState(null); //
  const [ordersInput, setOrdersInput] = useState({'name': '', 'value': ''}); //
  const [filters, setFilters] = useState(null);
  const [vehTypeFilters, setVehTypeFilters] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [openAgencyModals, setOpenAgencyModals] = useState(false);
  
  const [dropDownTypeOptions, setDropDownTypeOptions] = useState(filterPriorizationVehTypeOptions); //
  const [dropDownTypeValue, setDropDownTypeValue] = useState(''); //
  const [dropDownOptions, setDropDownOptions] = useState(filterPriorizationOptions); //
  const [dropDownValue, setDropDownValue] = useState(''); //

  const [selectedData, setSelectedData] = useState([]);
  const [openVehicleModal, setOpenVehicleModal] = useState(false);//
  const [vehicleModalData, setvehicleModalData] = useState([]);//
  const [dropDownValueBill, setDropDownValueBill] = useState('noFacturados'); //
  const filterArrays = (elemento, datas) => {
    const updatedArray1 = filteredData.filter((obj) => obj.chassis !== elemento.chassis);
    const updatedArray = updatedArray1.filter((obj) => obj.isSelected !== true);
    let temp2 = updatedArray.filter((item1) => {
      return elemento.masterCode === item1.masterCode &&
         elemento.sfx === item1.sfx &&
         elemento.externalColor === item1.externalColor &&
         elemento.reservationId === item1.reservationId &&
         elemento.daysOld < item1.daysOld;
    });
    return temp2;
  };


  const updateMyData = (rowIndex, columnId, value, row) => {
    const getNewData = (old) => {
      const newData = old.map((row, index) => {
        if (index === rowIndex) {
          const vehicleAdvicePriorization = filterArrays(old[rowIndex], filteredData);
          setvehicleModalData(vehicleAdvicePriorization);
          if (vehicleAdvicePriorization.length > 0 && value === true) {
            setOpenVehicleModal(true);
          }
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      });
      const selected = filteredData.filter((x) => {
        return x.isSelected;
      });
      
      if (selected.length === 1 && selected[0].chassis === row?.original.chassis && !value) {
        return applyFilters(
          {
            filteredData,
            data,
            filters,
            vehTypeFilters,
            setDropDownOptions,
            setDropDownValue,
            setDropDownTypeOptions,
            setDropDownTypeValue,
          }
        );
      }
      if (selectType === priorizationType) {
        return row ? newData.filter((x) => {
          return x.masterCode === row.original.masterCode && x.sfx === row.original.sfx &&
            x.reservationId === row.original.reservationId;
        }) : newData;
      }
      return newData;
    };

    setFilteredData((old) =>
      getNewData(old)
    );
  };

  const columnsTable = tableColumnsWithProps({
    setOpenOrders,
    setOrdersInput,
    selectMode,
    updateMyData,
    setSelectedVehicleCombo,
    setOpenComboModal,
    dispatch,
    fetchPriorizationCombos,
    userType,
    setOpenAgencyModals,
    setSelectedVehicleAgency,
    fetchAgenciesByDealer,
    isUserTDE,
  });

  
  useEffect(() => {
    setSelectedData(
      (filteredData.map((item, index) => ({...item, 'index': index})) || []).filter((item) => item.isSelected));
  }, [filteredData]);
  
  useEffect(() => {
    dispatch(fetchGetPriorizationData(dropDownValueBill));
  }, [dropDownValueBill]);

  useEffect(() => {
    !selectedData?.length && setOpenUpdateDates(false);
  }, [selectedData]);

  useEffect(() => {
    if (filters || vehTypeFilters) {
      setFilteredData(applyFilters(
        {
          filteredData,
          data,
          filters,
          vehTypeFilters,
          setDropDownOptions,
          setDropDownValue,
          setDropDownTypeOptions,
          setDropDownTypeValue,
        }
      ));
    } else {
      setFilteredData(data);
    }
  }, [filters, vehTypeFilters]);
  
  useEffect(() => {
    setSelectType(null);
    setSelectMode(false);
    setFilters(null);
    setVehTypeFilters(null);
    setFilteredData(data);
    setSelectedData([]);
    setOpenUpdateDates(false);
  }, [data]);

  useEffect(() => {
    dispatch(setSelectedVehicleAgency({
      'chassis': '',
      'dealerDestiny': '',
      'agency': '',
    }));
    dispatch(fetchGetFreeDatesLogistic());
    dispatch(fetchDealers('dealers-vehicles'));
  }, []);

  useEffect(() => {
    dispatch(fetchGetPriorizationData(dropDownValueBill));
    setOpenComboModal(false);
    setOpenUpdateDates(false);
    setOpenAgencyModals(false);
  }, [updateSuccess]);

  useEffect(() => {
    if (
      hasAccessPermission(permissions, resources.VehiclesPriorizationDates, scopes.LogisticEdit) ||
      hasAccessPermission(permissions, resources.VehiclesPriorizationDates, scopes.SalesEdit) ||
      hasAccessPermission(permissions, resources.VehiclesPriorizationDates, scopes.See)
    ) {
      if (hasAccessPermission(permissions, resources.VehiclesPriorizationDates, scopes.LogisticEdit, scopes.See)) {
        setUserType(scopes.LogisticEdit);
      } else if (hasAccessPermission(permissions, resources.VehiclesPriorizationDates, scopes.SalesEdit)) {
        setUserType(scopes.SalesEdit);
      } else {
        setUserType(scopes.See);
      }
    } else {
      dispatch(navigateTo(paths.AccessDenied));
    }
  }, []);


  useEffect(() => {
    if (selectType === datesType) {
      setDropDownTypeValue('');
    }
  }, [selectType]);

  return (
    <>
      <HeaderTitle
        isUserTDE={isUserTDE}
        selectMode={selectMode}
        setSelectMode={setSelectMode}
        filters={filters}
        setFilters={setFilters}
        setVehTypeFilters={setVehTypeFilters}
        filteredData={filteredTableData}
        columns={columnsTable}
        setOpenUpdateDates={setOpenUpdateDates}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        dropDownTypeOptions={dropDownTypeOptions}
        dropDownTypeValue={dropDownTypeValue}
        setDropDownTypeOptions={setDropDownTypeOptions}
        setDropDownTypeValue={setDropDownTypeValue}
        dropDownOptions={dropDownOptions}
        dropDownValue={dropDownValue}
        setDropDownOptions={setDropDownOptions}
        setDropDownValue={setDropDownValue}
        userType={userType}
        setSelectType={setSelectType}
        setDropDownValueBill={setDropDownValueBill}
        dropDownValueBill={dropDownValueBill}
      />
      <Card fluid>
        <PriorizationDateTable
          dataTable={filteredData}
          selectMode={selectMode}
          setFilteredTableData={setFilteredTableData}
          columnsTable={columnsTable}
          userType={userType}
          updateMyData={updateMyData}
          setDropDownValueBill={setDropDownValueBill}
          dropDownValueBill={dropDownValueBill}
        />
      </Card>

      <OrderModal
        openOrders={openOrders}
        ordersInput={ordersInput}
        setOpenOrders={setOpenOrders}
        setFilters={setFilters}
        loading={loading}
      />
      {selectType === datesType &&
        <UpdateDatesModal
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          openUpdateDates={openUpdateDates}
          setOpenUpdateDates={setOpenUpdateDates}
          updateMyData={updateMyData}
          userType={userType}
        />
      }
      {selectType === priorizationType &&
        <PriorizationModal
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          openUpdateDates={openUpdateDates}
          setOpenUpdateDates={setOpenUpdateDates}
          updateMyData={updateMyData}
          // userType={userType}
        />
      }
      <UpdateComboModal
        openComboModal={openComboModal}
        setOpenComboModal={setOpenComboModal}
      />
      <UpdateAgencyModal
        openAgencyModals={openAgencyModals}
        setOpenAgencyModals={setOpenAgencyModals}
      />
      <Modal open = {openVehicleModal}>
        <Modal.Header>
          Vehículos a ser priorizados
        </Modal.Header>
        <Modal.Content>
          {vehicleModalData[0] &&
            <div> Por favor priorizar el pedido {vehicleModalData[0].order} la línea {vehicleModalData[0].line} tiene
               mayor antiguedad de inventario. </div>
          }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenVehicleModal(false)}>
            Cancelar
          </Button>
        </Modal.Actions>
      </Modal>
      {loading && (
        <Dimmer active inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
      )}
    </>
  );
};

export default PriorizationDate;
